import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/connexion"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.user.role === "admin" ? "/admin" : "/compte", { replace: true });
      } catch { setError(true); }
    })();
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      {error ? (
        <p className="text-ink-muted">Échec de la connexion Google. <button onClick={() => nav("/connexion")} className="text-terracotta underline">Réessayer</button></p>
      ) : (
        <><div className="h-8 w-8 rounded-full border-2 border-terracotta border-t-transparent animate-spin" /><p className="text-ink-muted text-sm">Connexion en cours…</p></>
      )}
    </div>
  );
}
